import { useCallback, useEffect } from 'react';
import { inquiryApi } from '@texas/api/endpoints/inquiryApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { inquiryEvents } from './events';
import { useSignalSubscriptionEvents } from '@texas/components/shared/hooks/useSignalSubscriptionEvents';

export function useInquiryDetailContext(inquiryId: number) {
  const {
    data,
    loading,
    error,
    refetch: refetchInner,
    set,
  } = useApiResource(inquiryApi.getInquiry);

  useEffect(() => {
    refetchInner(inquiryId);
  }, [refetchInner, inquiryId]);

  const refetch = useCallback(
    () => refetchInner(inquiryId),
    [refetchInner, inquiryId],
  );

  useEffect(() => {
    return inquiryEvents.onVariantUpdated.subscribe((variantId) => {
      if (variantId === data?.variantId) refetch();
    });
  }, [data?.variantId, refetch]);

  useSignalSubscriptionEvents({
    signalEvents: [inquiryEvents.onUpdated],
    triggerOnEvent: () => {
      refetch();
    },
  });

  useEffect(() => {
    return inquiryEvents.onTierPricePatched.subscribe(({ tierId, price }) => {
      set((prev) => {
        if (!prev) return prev;
        return {
          ...prev,
          tierPrices: prev.tierPrices.map((tp) =>
            tp.id === tierId ? { ...tp, price } : tp,
          ),
          controlledInquiries: prev.controlledInquiries.map((ci) => ({
            ...ci,
            tierPrices: ci.tierPrices.map((tp) =>
              tp.id === tierId ? { ...tp, price } : tp,
            ),
          })),
        };
      });
    });
  }, [set]);

  return { data, loading, error, refetch };
}
